module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00058",
      "title": "[54]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_54"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00059"
    }
  }, [_vm._v("CHAPTER V")])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre drop-cap"
  }, [_vm._v("THE morning after the ball, Letty was aroused\nfrom the profound sleep of youth and exhaustion\nby a stealthy, grating sound, and opening her eyes, to\nher amazement she beheld Jones, the under-housemaid,\nkneeling on the hearth-rug, intent on kindling a\nparticularly sulky fire.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("As she raised herself on her elbow, blinking and bewildered,\nthe maid sat up on her heels and proceeded\nto explain the situation with glib volubility.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, miss, I’m sorry; the mistress gave orders you\nwere not to be disturbed, and I was to light your fire;\nbut there ain’t been one in the grate this forty year,\nand it’s a sore job. Hawkins is bringing up your\nbreakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("As she spoke, the door-handle turned and Hawkins\nentered, bearing with unusual pomp and circumstance\na heavily laden tray. Letty rubbed her eyes. Was she\nstill dreaming? Why were the two maids in waiting\nupon "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("her")]), _vm._v("? She was well aware that her aunt considered\nbedroom fires unnecessary, and breakfast in bed a\nslothful indulgence. She, however, dissembled her\nsurprise, and accepted these unexpected favours with\ncommendable composure.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00060",
      "title": "[55]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_55"
    }
  })]), _vm._v("Having nibbled at some buttered toast and swallowed\na cup of tea, she sprang out of bed to search for her\nprogramme, and survey herself in the glass. In the glass\nshe beheld an oval face, a pair of drowsy blue eyes, a\npair of soft pink cheeks, and a mass of tumbled brown\nhair. Was she beautiful? she wondered. Mr. Blagdon\nhad implied as much—indeed, more than implied.\nWhat bad manners to make blunt personal remarks!\nWell, "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("his")]), _vm._v(" opinion was of no consequence; but did\nother people think her pretty? (Other people naturally\nincluded Lancelot Lumley. She confessed to\nherself that she would like him to admire her.)")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Oh, how cold it was! She curled up her delicate\nlittle toes, and, programme in hand, plunged once\nmore into her comfortable nest. Here she prepared\nto study at leisure the exciting contents of her precious\ncard—no easy task. The card was covered with\nscribbled names, sketches, initials, stars, hieroglyphics,\ncorrections—and yet, on the whole, it made\nagreeable reading.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("In the midst of this interesting occupation the door\nopened very gently—the programme disappeared as\nif in the hands of a conjurer—and Mrs. Fenchurch\nadvanced into the room showing all her upper teeth,\na sure signal of unusual amiability.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Well, my dear girl,” she began, “how are you to-day?\n"), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Dead?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh no,” sitting erect; “I’m all right, thank you,\nAunt Dorothy.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I thought you’d better have a good sleep after"), _c('span', {
    attrs: {
      "id": "pgepubid00061",
      "title": "[56]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_56"
    }
  })]), _vm._v("\nyour first ball. My!” as her glance fell upon a tattered\ngarment, “look at your poor frock!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Yes, indeed, there was a large obtrusive rent in the\nskirt, and a streamer of ragged "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("crêpe")]), _vm._v(" made no attempt\nat concealment. Yet instead of the expected sharp\nscolding, Mrs. Fenchurch merely remarked:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“"), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("How")]), _vm._v(" you danced! You could have filled your\ncard ten times over. By the way, may I look at your\nprogramme? I see the blue tassel sticking out under\nyour pillow.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("With much reluctance, and deep and guilty blushes,\nLetty produced the desired treasure and yielded it to\nher visitor, who was now staring at her so fixedly, that\none would almost suppose that she beheld her for the\nfirst time! In her mind’s eye, Mrs. Fenchurch really\nwas contemplating an absolutely strange niece! So\nthis simple, timid, obedient, little schoolgirl, unconsciously\npossessed the fatal endowment, the wonderful,\ninvincible power, that has moved armies and fleets.\nUnquestionably, Letty had the gift; and her relative\nwas determined to turn it to the utmost advantage.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("With the record of her niece’s partners in her hand,\nMrs. Fenchurch seated herself, squarely, comfortably,\nand sociably on the bed, and proceeded to discuss the\nball, and its incidents, with all the zest and vivacity of\none of the girl’s own contemporaries.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“How well I remember "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("my")]), _vm._v(" first ball,” she said\nmeditatively; “I was so frightened my teeth actually\nchattered as we drove to it, and, after all, I enjoyed\nmyself enormously. I wore white, of course, looped up"), _c('span', {
    attrs: {
      "id": "pgepubid00062",
      "title": "[57]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_57"
    }
  })]), _vm._v("\nwith water lilies, and I remember a spiteful cousin\nasking me if they were not spinach and eggs! Girls\nare so jealous! Now let me see who you danced with—um—um—um——”\nnodding her head as her eyes\ntravelled over the card. “Lord Deloraine twice—but,\nof course, "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("he")]), _vm._v(" is married—and what about the Duke?”\nlooking up quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I had not a dance left.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Who is V. K.? Oh yes, I know—the Austrian\nAttaché staying with the Beauvoirs. H. B., H. B.,\nH. B. Oh, "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Letty")]), _vm._v("! How often did you dance with\nHugo Blagdon?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Two or three times,” she answered stiffly, having\nmade up her mind to give her aunt no satisfaction with\nrespect to this overbearing odious partner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“He took you in to supper, dear, too,” continued\nMrs. Fenchurch; “and, oh yes,” nodding her head\nand trying to look arch, “"), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("I")]), _vm._v(" saw you sitting together\nin the long corridor. Tell me, what did you talk\nabout?” and she gazed into the girl’s face with a pair\nof penetrating "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("asking")]), _vm._v(" eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("How Letty wished she would not stare at her in\nthis fashion, and breathe through her nose. Positively\nher aunt filled her with sheer physical terror—yes,\nand repulsion.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I really can’t remember, Aunt Dorothy. I think he\nsaid the supper was bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“But surely he paid you some pretty compliment?”\npersisted her tormentor. “Come now?” she urged\ncoaxingly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00063",
      "title": "[58]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_58"
    }
  })]), _vm._v("“I daresay he did—I—I forget.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Did he say anything about coming over here to\ncall?” and her tone was anxious.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I—I’m not sure,” murmured the girl, who mentally\nwrithed under this inquisition. Never in her life had\nshe felt so mortally shamefaced and shrinking. She\nlonged to pull the bedclothes over her head and\nhide herself away, from that inflexibly soliciting\ncountenance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Her reluctant replies were so vague and unsatisfactory,\nthat at last her chaperon realised she could\nnot get much out of Letty as yet—all in good time!\nAgain she gazed at her niece long and thoughtfully, as\nthough seeing in her a multitude of new possibilities;\nthen, rising, she said in her brisk, every-day manner:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I’ll tell Jones to bring up your bath water—it\nis nearly twelve o’clock,” and Mrs. Fen took her\ndeparture, leaving the girl with a grateful sense of\npressure removed, and a happy consciousness of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("When, an hour later, the beauty of the Hunt Ball\ndescended to the morning-room, she found herself still\nsurrounded by an atmosphere of indulgence and affection.\nHer aunt handed her a novel to read; as a rule\nlight literature was tabooed till nightfall—and at\nlunch Mrs. Fen helped her poor relation to the liver\nwing, and commanded Hawkins to give Miss Glyn a\nglass of claret.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("When Hawkins had withdrawn, after serving the\ncoffee, Mrs. Fenchurch cleared her throat and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“The Bonhams are having a young people’s dance"), _c('span', {
    attrs: {
      "id": "pgepubid00064",
      "title": "[59]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_59"
    }
  })]), _vm._v("\nthis day week, and Lady Bonham has asked me to go\nover and take you, Letty, and stay all night. How\nwould you like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“It would be delightful—another dance!” and her\neyes sparkled.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I’ve been talking to Fletcher this morning, and she\nthinks that if I have Mrs. Cope up from the village she\nmay be able to make the white brocade and the green\ncloth. I daresay you won’t mind giving a little assistance\nyourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“No, indeed, Aunt Dorothy. I shall be delighted.\nI’m rather good at sewing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, here comes Cousin Maude.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Well, Letty, here I am,” said Mrs. Hesketh, as she\nentered. “I’ve come to hear about the ball, how\neveryone looked and behaved, what they wore, who\nsat out as wallflowers, or otherwise? and I particularly\nwish to see your programme. I haven’t had one in\nmy hand for ten years. Where is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“How tiresome,” thought the girl; one would\nsuppose that her wretched little card, was something\nremarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("The programme happened to be at the top of the\nhouse, and when Letty returned with it in her hand\nshe found her aunt talking to Cousin Maude with unusual\n"), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("empressement")]), _vm._v(". She was sitting close beside her\non the sofa, pouring some important statement into\nher ear.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Whatever she was saying was interrupted by the\nentrance of her niece, who caught the words:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00065",
      "title": "[60]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_60"
    }
  })]), _vm._v("“Eyes for no one else!” Mrs. Fenchurch paused and\nnodded significantly at her companion, as much as to\nsay:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Of this—more later.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And so I hear your dress looked lovely, Letty, and\nthat you had a great success. Now hand me over\nthat programme,” said Mrs. Hesketh with a smile.\n“Ah, yes, I see every dance, and all manner of strange\nautographs and initials. I declare you ought to have\nthis photographed! And so you enjoyed yourself very\nmuch, dear child?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, immensely,” she answered, with a happy sigh;\nthe little drawbacks were now fading, the strains of a\ndelicious waltz were ringing in her ears, and she was\nfloating round the room in the arms of Lancelot\nLumley.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And you are going to a dinner and dance this day\nweek—why, you are getting quite gay!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Well, you see, Cousin Maude, I am ‘out’ now.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Yes, you have stretched your little wings and\nflown beyond the village into what is called the world.\nI wonder how you will like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Very much, I think, as far as I have seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And that amounts to one ball. What experience!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Letty has not seen much,” admitted Mrs. Fenchurch;\n“but our little world has now seen "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("her")]), _vm._v(",” and\nshe smiled complacently. “Ah, there is Wilson, of\ncourse, somebody wants me. Oh, I really never have\nfive minutes to myself. I expect it is about the"), _c('span', {
    attrs: {
      "id": "pgepubid00066",
      "title": "[61]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_61"
    }
  })]), _vm._v("\ncarpenter. Don’t go away before I come back,\nMaudie,” and she bustled out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Now, my dear child,” said Mrs. Hesketh, dragging\nher down beside her on the sofa, “tell me really and\ntruly, all about last evening. Was it as nice as you\nexpected?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Yes—every bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And which of your partners did you like the best?\nCome, honour bright.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Letty reflected for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“As far as dancing went, there was an Austrian\nAttaché who danced like a dream—but, of course, I\nknew Mr. Lumley before.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And what of Mr. Blagdon?” enquired her friend\nwith a searching look.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, he was rather heavy, and easily tired and out\nof breath—of course, he is old.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Old! Why, I don’t believe he is a day more than\nsix or seven and thirty, the prime of life! Apparently\nLancelot Lumley and Mr. Blagdon were your two\nmost favoured partners—but, my dear girl, I cannot\nallow you to have anything to say to either of\nthem.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Letty burst into a ringing laugh: her laugh was\nspontaneous and delightful.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Why not?” she demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“One is too poor, and the other is too rich.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“But, Cousin Maudie, surely one doesn’t think of\nsuch things as future husbands—just at a dance?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, well, I don’t suppose that "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("you")]), _vm._v(" do,” and"), _c('span', {
    attrs: {
      "id": "pgepubid00067",
      "title": "[62]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_62"
    }
  })]), _vm._v("\nshe turned away and stared into the fire. For\nseveral minutes she did not speak, then at last she\nsaid:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“You must promise never to take a fancy to anybody\nwithout giving me due notice, and the next time\nyou go to a dance you are to leave your heart with me.\nYou shall have it back with interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I don’t think I have that kind of heart. I’m\nafraid my heart is hard; I don’t care for many\npeople; but I am very very fond of uncle and of\nyou—and of Sam.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And where does your aunt come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Well, you see, Aunt Dorothy is not—er—my own\naunt. I don’t fancy that she has much sympathy with\ngirls—her mind is taken up with other things.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Yes, she is a born administrator and manager;\nnot merely of her own affairs; she has a wide\nhorizon. I believe one of her ancestors must have\nbeen a Prime Minister. Doodie is ready to take a\nhand in anyone’s life, and at a moment’s notice.\nSupposing a stranger were to fall ill in the village,\nshe would come forward at once, find them a nurse\nand doctor; if they died, wire to their friends, arrange\nfor the funeral, buy the grave, and see that they\nwere laid in it! In your case, she is not contemplating\na funeral—but a wedding!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I—I—don’t understand,” stammered the girl.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Don’t you, my simple darling? Well, there is one\nfact that you may possibly grasp—your aunt is monstrously\nproud of you; the Chippendale sideboard, and"), _c('span', {
    attrs: {
      "id": "pgepubid00068",
      "title": "[63]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_63"
    }
  })]), _vm._v("\nthe three-year-old thoroughbred are for the present\nlanguishing in the cold shade. Ah, here she comes!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("The white brocade (trimmed with lace instead of the\ndespised green ribbon) was completed in good time,\nand Letty and her aunt, with their luggage on the carriage,\ndrove off to Bonham Court in high spirits. It\nwas a large, rambling old place, occupied by a childless\ncouple who had a passion for the society of young\npeople. First of all, there was a merry gathering at\ntea in the big hall. Here Mrs. Fenchurch was agreeably\nsurprised to recognise Mr. Blagdon, who welcomed her\nand her niece with flattering cordiality.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("At dinner pretty Miss Glyn was his "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("vis-à-vis")]), _vm._v("; she\nwas placed between two boys—an Etonian and a\nyoung fellow lately gazetted to the Guards—and they\nappeared to be enjoying themselves immensely. He\nhad every opportunity of studying her at his leisure,\nignoring his partner—who noticed, with smouldering\nresentment, that his whole attention was devoted to\nthe little girl opposite—a Miss Glyn that everyone was\ntalking about. She certainly had a wonderful complexion—if\nit was her own!—and a profile, clear cut\nas a cameo—yes—and youth! The neglected lady\nasked herself if it could be possible, that this hopelessly\ndull "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("parti")]), _vm._v(", who sat beside her drinking glass\nafter glass of champagne, was thinking seriously of\nthat simple and innocent child?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("After dinner there was dancing in the great hall."), _c('span', {
    attrs: {
      "id": "pgepubid00069",
      "title": "[64]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_64"
    }
  })]), _vm._v("\nMr. Blagdon danced several times with Letty, and she\nfound him less formidable than on the former occasion,\nnot so grand, detached, or condescending. She liked\nhim better, or to put it more correctly, disliked him\nless. He now talked as an ordinary partner, and not\nas a far-removed magnificent potentate; spoke of his\ndogs and horses and gardens, and hoped that she\nmight one day see them!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Subsequently he made himself conspicuously attentive\nto Mrs. Fenchurch, sat out with her, and engaged\nher in a long conversation in the drawing-room, promenaded\nby her side in the picture gallery, and finally\nconducted her to supper. This, to the experienced,\nwas a registered symptom that the great Blagdon\nhad intentions respecting the lady’s niece! and the\nsame happy matron, as she sat beside him at\ntable, had much ado to quench the exultation in\nher face.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("The following afternoon the party broke up, and the\ngay and cheery company that sped Letty and her\naunt, little guessed how the girl shrank from the impending\nand enforced "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("tête-à-tête")]), _vm._v(" in the family brougham.\nShe dreaded the ordeal as if she were about to undergo\nsome painful physical operation; with all her muscles\ntense, and leaning far back in her corner, she submitted,\nwhilst her companion, in her most insinuating voice,\nso to speak, put the question or questions, in return\nreceiving, it must be confessed, very brief, and crooked\nanswers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("The hall door stood wide as they drove up to The"), _c('span', {
    attrs: {
      "id": "pgepubid00070",
      "title": "[65]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_65"
    }
  })]), _vm._v("\nHolt. Standing on the steps in the full light, Colonel\nFenchurch shouted a hearty welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("He backed into the hall in front of the arrivals,\ntalking all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Missed you both desperately—no piquet—no\nmusic—ready to hang myself last night. I say, I’ve\nkept the toast and scones warm inside the fender—tea\nwill be ready in a jiff. Lots of letters for you,\nDoodie.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("As they entered the warm, well-lighted drawing-room,\nhe turned about to face the ladies, and noticed\nthat his little girl looked brilliantly pretty, as she laid\nher cold cheek against his, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Such a delightful party, Uncle Tom, and one of\nthe Barrons—Sophy—was at my school.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Yes, he said to himself, it was nice for the child\nto mix with young people of her own age—it did\nher good.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("When tea was over and uncle and niece found themselves\nalone, she came and sat on the arm of his chair,\nand rattled off an amusing description of her visit, and\nrepeated for his entertainment many of the jokes and\nanecdotes that had been bandied about among the\ncompany: enumerated the names of the guests, and\neven of the Bonham house dogs, but made no mention\nwhatever of the great Hugo Blagdon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Mrs. Fenchurch felt unusually elated: being firmly\npersuaded that she was about to have the glory and"), _c('span', {
    attrs: {
      "id": "pgepubid00071",
      "title": "[66]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_66"
    }
  })]), _vm._v("\ngratification of setting in motion a triumphal drama\nof real life; and the morning after her return she\nsought her husband in the smoking-room, generously\nresolved, that he, too, should have a share in her\nglorious expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Having carefully closed the door, she came and\nstood by the fire, and said in a low and almost\nawestruck voice:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“"), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Hugo Blagdon was there, Tom.")]), _vm._v(" I was so surprised!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("Her husband put down his pipe, and stared at her\nstupidly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Why, what is surprising about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Oh, nothing, except that he is immensely struck\nwith Letty; he as much as told me so.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Did he, indeed!” sitting erect. “I don’t think\nmy little Letty would suit him at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“You will allow, Tom, that he knows best; a man\nof his age has some idea of the sort of girl he admires\nby this time!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Humph!” he grunted, “I have never known him\nadmire a "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("girl")]), _vm._v(" yet—it’s always been the married women\nhe runs after.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“That run after him, you mean,” she corrected.\n“Well, I think he has made up his mind to settle at\nlast.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I hope to goodness he hasn’t made up his mind to\nsettle on my niece. For one thing, he is twenty years\nolder than she is—if not more—a blasé fellow who has\nknocked about the world and been his own master (and,"), _c('span', {
    attrs: {
      "id": "pgepubid00072",
      "title": "[67]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_67"
    }
  })]), _vm._v("\nby all accounts, a bad one) since he was sixteen. Why\nthe stories about him and Mrs. Corbett—scandalous\nstories—are common property.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“He is a very good sort—if no saint,” declared his\nwife. “I know you have a prejudice against him—because\nthe Lumleys don’t like him, and you like\nthe Lumleys; but you cannot deny that he is\npopular?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“A man with forty thousand a year is bound to be\nthat,” growled her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“He is extremely liberal, and subscribes to everything,”\ncontinued Mrs. Fenchurch. “I believe Letty\nwould be the most fortunate girl in England, if she was\nMrs. Blagdon. He is certainly thinking of marrying—for\nthe place is entailed, and if anything were to happen\nto him, every acre of the property would go to a\ncousin in New Zealand, whom he loathes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“And you think he is going to take a wife, if it is\nonly to spite his cousin, eh, Doodie?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“I think, my dear Tom, that you are in one of your\nfunny tempers this morning—you smoke too much, or\nyou have got a chill on your liver,” and she patted him\nlightly on the head. “Why, you ought to be enchanted\nat your niece’s prospects! She is just the sort of little\nthing that will take to wealth and luxury, like a duck\nto water.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Since you go to the poultry-yard for your similes,\nit’s my opinion, that you are counting your chickens\nbefore they are hatched. What has put this ridiculous\nidea into your head? Has he "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("said")]), _vm._v(" anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00073",
      "title": "[68]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_68"
    }
  })]), _vm._v("“No—not in so many words—but he is coming over\nhere to lunch on Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“To lunch——for what?” he demanded, and his\ntone was sharp and inhospitable.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“He says,” she hesitated for a moment, “he says,\nhe has heard a great deal of our—chrysanthemums.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("“Twenty miles’ drive to look at half a dozen pots\nof chrysanthemums! "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Bah!")]), _vm._v("” and Colonel Fenchurch\nsprang to his feet, snatched up his cap, and went out\nof the room.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0